/**
 * The signed-in home's welcome (web-account-pages, signed-in-home.html Variant B
 * Band 4): Welcome back with the client's name, above the next session; with
 * nothing booked, the welcome on its own with Book a session and the last
 * session the client had.
 */
import { definePiece } from '../../contract/define';

export const contract = definePiece({
  name: 'home-welcome',
  description: "The signed-in home's welcome: Welcome back with the client's name, and Book a session when nothing is booked.",
  options: {},
  parts: {
    label: { description: 'The line Welcome back, <name>, with · Your next session when one is booked.', required: false },
    name: { description: "The client's first name in the welcome.", required: false },
    empty: { description: 'With nothing booked: the welcome, Nothing on the calendar yet, and Book a session.', required: false },
    lastSession: { description: 'With nothing booked: the last session the client had, or nothing.', required: false },
    book: { description: 'Book a session, to the services.', required: false, role: 'primary-action' },
    bookAgain: { description: "With nothing booked: Book <the last session> again, to its service page (Events for an event).", required: false, role: 'secondary-action' },
  },
  actions: {
    open: { description: 'Opens a page of the site (Book a session opens the services).', args: [{ name: 'href', kind: 'value', type: 'string', format: 'path' }] },
  },
  events: {},
});

/** What the welcome knows. */
export interface HomeWelcomeState {
  /** loading until the client's bookings are read. */
  readonly status: 'loading' | 'ready';
  /** The client's first name. */
  readonly firstName: string;
  /** True when a session is booked: the welcome is the next session's label. */
  readonly hasNext: boolean;
  /** "Your last session was Swedish Relaxation with Noor Hadley on Sat, Oct 3.", or null. */
  readonly lastSession: string | null;
  /** Where Book a session goes. */
  readonly bookHref: string;
  /** With nothing booked: "Book Swedish Relaxation again" and its service page, or null. */
  readonly bookAgain: { readonly label: string; readonly href: string } | null;
}

/** What a drawing can ask the welcome to do. */
export interface HomeWelcomeActions {
  /** Open a page of the site. */
  readonly open: (href: string) => void;
}

/** The welcome tells its host nothing. */
export type HomeWelcomeEvents = Record<string, never>;
